import i18n from '@/plugins/i18n'
import NumberFormatter from '@/helpers/numberFormatter'
import { DynamicData, DynamicInput } from '@/types/filters'

function formatMonth(val: string) {
  switch (val) {
    case '01':
      return i18n.t('month.txt.January')
    case '02':
      return i18n.t('month.txt.February')
    case '03':
      return i18n.t('month.txt.March')
    case '04':
      return i18n.t('month.txt.April')
    case '05':
      return i18n.t('month.txt.May')
    case '06':
      return i18n.t('month.txt.June')
    case '07':
      return i18n.t('month.txt.July')
    case '08':
      return i18n.t('month.txt.August')
    case '09':
      return i18n.t('month.txt.September')
    case '10':
      return i18n.t('month.txt.October')
    case '11':
      return i18n.t('month.txt.November')
    case '12':
      return i18n.t('month.txt.December')
    default:
      return val
  }
}
export const formatDate = (date: string) => {
  if (!date) return
  const dateArray = date.split('-')
  const year = dateArray[0]
  const month = formatMonth(dateArray[1])
  const day = dateArray[2]

  return `${day} ${month} ${year}`
}

export const truncate = (text: string, length: number): string => {
  if (!text || length <= 0) return text

  return text.substring(0, length)
}

export const formatPrice = (value: number, currencySymbol: string) => {
  const numberFormatter = NumberFormatter.getInstance()
  const formatedValue = numberFormatter.format(value).replace(/\.00$/, '')

  if (currencySymbol) return `${currencySymbol} ${formatedValue}`

  return formatedValue
}

export const getOrganizationIdsWithText = (data: DynamicInput<DynamicData>) => {
  const organizationIds = new Set()

  for (const category in data) {
    const categoryData = data[category]
    for (const entry of categoryData) {
      const organizationIdObject = {
        key: 'ownerId',
        text: entry.organizationId
      }
      organizationIds.add(organizationIdObject)
    }
  }

  return organizationIds
}

export const formatRelationsData = (inputData: DynamicInput<DynamicData>) => {
  const rolesByAccount: {
    [key: string]: string[]
  } = {}

  const currAccountKey = 'My account'

  // Check if inputData is null or undefined
  if (!inputData) {
    return []
  }

  for (const key in inputData) {
    if (key.toString().match(/owner/i)) {
      rolesByAccount[currAccountKey] = ['Truck']

      continue
    }
    const items = inputData[key]

    // Check if items array exists and is not empty
    if (!items || !Array.isArray(items)) {
      continue
    }

    for (const item of items) {
      // Check if item exists and has accountName property
      if (!item || !item.accountName) {
        continue
      }

      const { accountName } = item

      let accountRoles = rolesByAccount[accountName]
      if (!accountRoles) {
        accountRoles = []
        rolesByAccount[accountName] = accountRoles
      }
      accountRoles.push(key)
    }
  }

  return Object.keys(rolesByAccount).map(accountName => ({
    text: accountName,
    key: rolesByAccount[accountName].join(','),
    roles: rolesByAccount[accountName],
    sortHint: accountName === currAccountKey ? 0 : currAccountKey.toLowerCase()
  }))
}
